import { render } from "./ModalNuovoIntervento.vue?vue&type=template&id=1189f2f0&scoped=true"
import script from "./ModalNuovoIntervento.vue?vue&type=script&lang=js"
export * from "./ModalNuovoIntervento.vue?vue&type=script&lang=js"

import "./ModalNuovoIntervento.vue?vue&type=style&index=0&id=1189f2f0&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1189f2f0"]])

export default __exports__